// extracted by mini-css-extract-plugin
module.exports = {"container":"FormContainer_container___Ycjx","text":"FormContainer_text__c7UC0"};